import { isPPLFrontend } from '@root/src/utils/app-paths';

export const HOURS = Array.from({ length: 24 }, (_, i) => i);
export const MINUTES = Array.from({ length: 60 }, (_, i) => i);
export const TIME_FORMAT = isPPLFrontend ? 'HH:mm:ss' : 'HH:mm:ss.SSSZ';
